import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { openNotification } from "src/components/helpers/notification"
import ax from "src/store/config"
import axFile from "src/store/configFile"

const initialState = {
  trainersList: null,
  trainersListLoading: false,
}

export const postTrainerPacket = createAsyncThunk(
  "postTrainerPacket",
  async (payload, { dispatch }) => {
    dispatch(setTrainersListLoading(true))
    try {
      const { data } = await ax.put(
        "/api/admin/directory/createPersonalPackets",
        payload.value,
      )
      data && dispatch(setTrainersListLoading(false))
      return (
        data &&
        openNotification({
          type: "success",
          message: `Пакет успешно добавлен`,
        })
      )
    } catch (error) {
      dispatch(setTrainersListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
      return error
    }
  },
)

export const trainersAction = createAsyncThunk(
  "trainers/trainersAction",
  async (payload) => {
    try {
      let data
      const url = "/api/admin/directory/trainers"
      switch (payload.flag) {
        case "get":
          ;({ data } = await ax.get(url, { params: payload.value }))
          return data

        case "post":
          debugger
          ;({ data } = await axFile.post(url, payload.value))
          openNotification({
            type: "success",
            message: `Тренер успешно отредактирован`,
          })
          break

        case "put":
          ;({ data } = await axFile.put(url, payload.value))
          openNotification({
            type: "success",
            message: `Тренер успешно добавлен`,
          })
          break

        case "delete":
          ;({ data } = await ax.delete(url, { params: payload.value }))
          openNotification({
            type: "success",
            message: `Тренер успешно удален`,
          })
          break

        default:
          break
      }
    } catch (error) {
      debugger
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      })
      return error
    }
  },
)

// export const trainersAction = createAsyncThunk(
//   "trainersAction",
//   async (payload, { dispatch }) => {
//     dispatch(setTrainersListLoading(true))
//     try {
//       let data
//       const url = "/api/admin/directory/trainers"
//       switch (payload.flag) {
//         case "get":
//           ;({ data } = await ax.get(url, { params: payload.value }))
//           data && dispatch(setTrainersListLoading(false))
//           return data

//         case "post":
//           ;({ data } = await axFile.post(url, payload.value))
//           data &&
//             openNotification({
//               type: "success",
//               message: `Тренер успешно отредактирован`,
//             })
//           break

//         case "put":
//           ;({ data } = await axFile.put(url, payload.value))
//           data &&
//             openNotification({
//               type: "success",
//               message: `Тренер успешно добавлен`,
//             })
//           break

//         case "delete":
//           ;({ data } = await ax.delete(url, { params: payload.value }))
//           data &&
//             openNotification({
//               type: "success",
//               message: `Тренер успешно удален`,
//             })
//           break

//         default:
//           break
//       }
//     } catch (error) {
//       dispatch(setTrainersListLoading(false))
//       openNotification({
//         type: "error",
//         message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
//       })
//       return error
//     }
//   },
// )

const TrainersSlice = createSlice({
  name: "trainers",
  initialState,
  reducers: {
    setTrainersListLoading: (state, action) => {
      state.trainersListLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(trainersAction.pending, (state, action) => {  
        state.trainersListLoading = true
    })
    builder.addCase(trainersAction.fulfilled, (state, action) => {
      state.trainersListLoading = false
      state.trainersList = action.payload
    })
     builder.addCase(trainersAction.rejected, (state, action) => {
      state.trainersListLoading = false
      // state.trainersList = action.payload
    })
  },
})

export const { setTrainersListLoading } = TrainersSlice.actions

export default TrainersSlice.reducer
